import { VODEntitlementRequestModel } from './vod-entitlement.request.model';

export class GetVODEntitlementsRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetVODEntitlementsRequestMessage!: VODEntitlementRequestModel;
}
